export default class Modal {
  /**
   * @param {object} [options]
   * @param {object | null | undefined} [options.lenisController] LenisController 相当（stop / start / getInstance を実装していること）
   */
  constructor(options = {}) {
    this.lenisController = options.lenisController ?? null;
    this.savedScrollY = 0;

    this.modals = document.querySelectorAll('.modal');
    this.openButtons = document.querySelectorAll('[data-modal-open]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');
    if (!this.modals.length) return;
    this.init();
  }

  init() {
    this.openButtons.forEach(button => {
      button.addEventListener('click', () => {
        const modalId = button.getAttribute('data-modal-open');
        const modal = document.getElementById(modalId);
        if (modal) this.open(modal);
      });
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        const modal = button.closest('.modal');
        if (modal) this.close(modal);
      });
    });

    this.modals.forEach(modal => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          this.close(modal);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.modal[aria-hidden="false"]');
        if (openModal) this.close(openModal);
      }
    });
  }

  /**
   * Lenis が html の className を文字列で更新する際に連続スペースが残ることがあるため整える
   */
  normalizeDocumentElementClasses() {
    const root = document.documentElement;
    root.className = root.className.replace(/\s+/g, ' ').trim();
  }

  lockScroll() {
    const html = document.documentElement;
    const scrollbarWidth = window.innerWidth - html.clientWidth;

    this.lenisController?.stop?.();
    this.normalizeDocumentElementClasses();

    const lenis = this.lenisController?.getInstance?.();
    this.savedScrollY = typeof lenis?.scroll === 'number' ? lenis.scroll : window.scrollY;

    html.classList.add('is-modal-open');
    document.body.classList.add('is-modal-open');

    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    if (scrollbarWidth > 0) {
      html.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  unlockScroll() {
    const html = document.documentElement;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    html.classList.remove('is-modal-open');
    document.body.classList.remove('is-modal-open');
    html.style.paddingRight = '';

    window.scrollTo(0, this.savedScrollY);

    this.lenisController?.start?.();
    this.normalizeDocumentElementClasses();
  }

  open(modal) {
    modal.setAttribute('aria-hidden', 'false');
    this.lockScroll();

    const focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) {
      setTimeout(() => focusable.focus(), 100);
    }
  }

  close(modal) {
    modal.setAttribute('aria-hidden', 'true');
    this.unlockScroll();

    const triggerId = modal.id;
    const triggerButton = document.querySelector(`[data-modal-open="${triggerId}"]`);
    if (triggerButton) {
      triggerButton.focus();
    }
  }
}
